import { call, put, takeEvery } from 'redux-saga/effects';
import { authApi, LoginCredentials } from '../../services/authApi';
import {
	loginStart,
	loginSuccess,
	loginFailure,
	logout as logoutAction,
	setUser,
} from '../reducers/authSlice';
import { PayloadAction } from '@reduxjs/toolkit';

function* loginApi(action: PayloadAction<LoginCredentials>): Generator<any, void, any> {
	try {
		const response = yield call(authApi.login, action.payload);
		if (response.success) {
			yield put(loginSuccess(response.user));
		} else {
			yield put(loginFailure(response.message || 'Login failed'));
		}
	} catch (error: any) {
		yield put(loginFailure(error.message || 'Login failed'));
	}
}

function* logoutApi(): Generator<any, void, any> {
	try {
		yield call(authApi.logout);
		yield put(logoutAction());
	} catch (error: any) {
		yield put(logoutAction());
	}
}

function* getCurrentUserApi(): Generator<any, void, any> {
	try {
		const user = yield call(authApi.getCurrentUser);
		yield put(setUser(user));
	} catch (error: any) {
		yield put(logoutAction());
	}
}

export function* authSaga(): Generator<any, void, any> {
	yield takeEvery(loginStart.type, loginApi);
	yield takeEvery(logoutAction.type, logoutApi);
	yield takeEvery(setUser.type, getCurrentUserApi);
}

export default authSaga; 